/**
 * Search guard — stops empty search submits.
 *
 * GA, 30 days to 2026-09-05: 387 `view_search_results` events across 244
 * sessions carried an empty search term, and `/search?q=` renders a blank page
 * (sections/main-search.liquid only paints results when `search.performed`).
 * All three storefront forms are plain GET forms with no validation, and the
 * mobile overlay autofocuses an empty field next to a submit button, so a
 * mistaken tap costs the shopper the page they were on.
 *
 * Applies to every `form[role="search"]`: desktop header, mobile mega drawer,
 * and the mobile overlay.
 */
(function () {
  'use strict';

  var HINT_CLASS = 'search-guard__hint';
  var MESSAGE = '請先輸入想找的商品或品牌';

  function inputOf(form) {
    return form.querySelector('input[name="q"]');
  }

  function showHint(form, input) {
    var hint = form.querySelector('.' + HINT_CLASS);
    if (!hint) {
      hint = document.createElement('span');
      hint.className = HINT_CLASS;
      hint.setAttribute('role', 'status');
      form.appendChild(hint);
    }
    hint.textContent = MESSAGE;
    hint.classList.add('is-visible');
    clearTimeout(form._guardTimer);
    form._guardTimer = setTimeout(function () {
      hint.classList.remove('is-visible');
    }, 2600);
    if (input) {
      input.setAttribute('aria-invalid', 'true');
      try { input.focus({ preventScroll: false }); } catch (e) { input.focus(); }
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('role') !== 'search') return;
    var input = inputOf(form);
    if (!input) return;
    if (input.value.trim() === '') {
      e.preventDefault();
      showHint(form, input);
    }
  }, true);

  // Clear the invalid state as soon as they start typing.
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || input.name !== 'q') return;
    input.removeAttribute('aria-invalid');
    var form = input.form || input.closest('form');
    var hint = form && form.querySelector('.' + HINT_CLASS);
    if (hint) hint.classList.remove('is-visible');
  }, true);
})();
